import '../style/css.js'

import { StaticQuery, graphql } from 'gatsby'
import Helmet from 'react-helmet'
import React, { useContext } from 'react'

import PropTypes from 'prop-types'

import EnquiryForm from './enquiryForm'
import EnquiryFormJp from './enquiryFormJp'
import EnquiryFormCh from './enquiryFormCh'
import Footer from './footer'
import FooterJp from './footerJp'
import FooterCh from './footerCh'
import Header from './header'
import logo from '../images/logo-one-mastery.svg'

import GlobalContextProvider from '../context/GlobalContextProvider'

if (typeof window !== 'undefined') require('smooth-scroll')('a[href*="#"]')

const Layout = ({ children, lang, alt_hero_logo, utm_campaign, utm_source, utm_medium }) => (
	<StaticQuery
		query={graphql`
			query SiteTitleQuery {
				site {
					siteMetadata {
						title
					}
				}
			}
		`}
		render={(data) => (
			<GlobalContextProvider>
				<Helmet
					title={data.site.siteMetadata.title}
					meta={[
						{
							name: 'description',
							content:
								'Experience a new level of design. Luxury apartments coming soon to Waterloo.',
						},
						{
							name: 'keywords',
							content: 'apartments, sydney, waterloo, onespace, mastery',
						},
						{
							name: 'facebook-domain-verification',
							content: 's77936wwout8md0m89kbmjjk6vw0qx',
						},
						{
							name: 'robots',
							content: 'noindex, nofollow',
						},
					]}
				>
					<html lang='en' />
				</Helmet>

				{lang === 'jp' ? (
					<Header
						logo={alt_hero_logo ?? logo}
						lang={lang}
						hierarchy={[
							{ label: 'ホーム', url: '/jp' },
							{ label: 'ヴィジョン', url: '/jp/vision-jp' },
							{ label: 'プリシンクト', url: '/jp/precinct-jp' },
							// {
							// 	label: '建物',
							// 	children: [
							// 		// { label: 'ビルA', url: '/jp/architecture/building-a-jp' },
							// 		// { label: 'ビルB', url: '/jp/architecture/building-b-jp' },
							// 		// { label: 'ビルC', url: '/jp/architecture/building-c-jp' },
							// 		// { label: 'ビルD', url: '/jp/architecture/building-d-jp' },
							// 		// { label: 'ビルE', url: '/jp/architecture/building-e-jp' },
							// 		{ label: 'EBISU', url: '/architecture/ebisu-jp' },
							// 	],
							// },
							{ label: 'インテリア', url: '/jp/interiors-jp' },
							{ label: 'ロケーション', url: '/jp/location-jp' },
							// { label: '機会', url: '/jp/opportunity-jp' },
							{ label: 'Team', url: '/jp/team-jp' },
							{ label: 'Now Selling', url: '/now-selling-jp/ebisu-js' },
						]}
					></Header>
				) : lang === 'ch' ? (
					<Header
						logo={alt_hero_logo ?? logo}
						lang={lang}
						hierarchy={[
							{ label: '主页', url: '/ch/' },
							{ label: '愿景', url: '/ch/vision-ch' },
							{ label: '街区', url: '/ch/precinct-ch' },
							// {
							// 	label: '建筑',
							// 	children: [
							// 		// { label: 'A座', url: '/ch/architecture/building-a-ch' },
							// 		// { label: 'B座', url: '/ch/architecture/building-b-ch' },
							// 		// { label: 'C座', url: '/ch/architecture/building-c-ch' },
							// 		// { label: 'D座', url: '/ch/architecture/building-d-ch' },
							// 		// { label: 'E座', url: '/ch/architecture/building-e-ch' },
							// 		{ label: 'EBISU', url: '/architecture/ebisu-ch' },
							// 	],
							// },
							{ label: '内饰', url: '/ch/interiors-ch' },
							{ label: '位置', url: '/ch/location-ch' },
							// { label: '机遇', url: '/ch/opportunity-ch' },
							{ label: 'Team', url: '/ch/team-ch' },
							{ label: 'Now Selling', url: '/ch/now-selling/ebisu-ch' },
						]}
					></Header>
				) : (
					<Header
						logo={alt_hero_logo ?? logo}
						lang={lang}
						hierarchy={[
							{ label: 'Home', url: '/' },
							{ label: 'Vision', url: '/vision' },
							{ label: 'Precinct', url: '/precinct' },
							// {
							// 	label: 'Architecture',
							// 	children: [
							// 		// { label: 'Building A', url: '/architecture/building-a' },
							// 		// { label: 'Building B', url: '/architecture/building-b' },
							// 		// { label: 'Building C', url: '/architecture/building-c' },
							// 		// { label: 'Building D', url: '/architecture/building-d' },
							// 		// { label: 'Building E', url: '/architecture/building-e' },
							// 		{ label: 'EBISU', url: '/architecture/ebisu' },
							// 	],
							// },
							{ label: 'Interiors', url: '/interiors' },
							{ label: 'Location', url: '/location' },
							// { label: 'Opportunity', url: '/opportunity' },
							{ label: 'Team', url: '/team' },
							{ label: 'Now Selling', url: '/now-selling/ebisu' },
						]}
					></Header>
				)}

				{children}

				{lang === 'jp' ? (
					// The AWS integration will need to be duplicated.
					<EnquiryFormJp
						to='https://vds9c5imf1.execute-api.ap-southeast-2.amazonaws.com/prod/one-mastery'
						utm_campaign={utm_campaign}
						utm_source={utm_source}
						utm_medium={utm_medium}
					/>
				) : lang === 'ch' ? (
					// The AWS integration will need to be duplicated.
					<EnquiryFormCh
						to='https://vds9c5imf1.execute-api.ap-southeast-2.amazonaws.com/prod/one-mastery'
						utm_campaign={utm_campaign}
						utm_source={utm_source}
						utm_medium={utm_medium}
					/>
				) : (
					// The AWS integration will need to be duplicated.
					<EnquiryForm
						to='https://vds9c5imf1.execute-api.ap-southeast-2.amazonaws.com/prod/one-mastery'
						utm_campaign={utm_campaign}
						utm_source={utm_source}
						utm_medium={utm_medium}
					/>
				)}

				{lang === 'jp' ? (
					<FooterJp
						address="30-36 O'Dea Avenue, Waterloo NSW 2017"
						logoLinkUrl=''
						openHours='週7日間、午前10時～午後4時'
						socialLinks={{
							facebook : 'https://www.facebook.com/One-Space-Residences-and-Resorts-111218915019004',
							instagram: 'https://www.instagram.com/onespace_residences/',
							twitter  : 'https://www.tiktok.com/@onespace_residences',
							// youtube  : 'https://www.youtube.com/channel/UCFqtysbzDIz0AwXxk2zNWgg',
							// linkedin : 'https://www.linkedin.com/company/crown-international-holdings-group/',
							// wechat   : 'http://www.crowngroup.com.au/wechat/',
							// weibo    : 'http://www.weibo.com/crownpropertygroup',
						}}
						teams={[
							{
								name: 'ジャパンチーム（販売代理）',
								detail:
									'スターツコーポレーション株式会社 国際事業本部<br/><br/>〒103-0027 東京都中央区日本橋3-4-10<br/>スターツ八重洲中央ビル 7階',
								email: 'kaigai@starts.co.jp',
								phone: '03-6202-0148',
							},
							{
								// name: "ジャカルタチーム",
								// phone: "+62 878 98888 098",
								// detail: "英語、インドネシア語",
								// email: "sales@onespacegroup.com.au"
							},
						]}
					/>
				) : lang === 'ch' ? (
					<FooterCh
						address="30-36 O'Dea Avenue, Waterloo NSW 2017"
						logoLinkUrl=''
						openHours='展销中心每天上午10点至下午4点开放，每周开放7天'
						socialLinks={{
							facebook : 'https://www.facebook.com/One-Space-Residences-and-Resorts-111218915019004',
							instagram: 'https://www.instagram.com/onespace_residences/',
							twitter  : 'https://www.tiktok.com/@onespace_residences',
							// youtube  : 'https://www.youtube.com/channel/UCFqtysbzDIz0AwXxk2zNWgg',
							// linkedin : 'https://www.linkedin.com/company/crown-international-holdings-group/',
							// wechat   : 'http://www.crowngroup.com.au/wechat/',
							// weibo    : 'http://www.weibo.com/crownpropertygroup',
						}}
						teams={[
							{
								name: '悉尼团队',
								phone: '1800 931 680',
								detail: '普通话、粤语和印尼语',
								email: 'sales@onespacegroup.com.au',
							},
							{
								// name: "ジャカルタチーム",
								// phone: "+62 878 98888 098",
								// detail: "英語、インドネシア語",
								// email: "sales@onespacegroup.com.au"
							},
						]}
					/>
				) : (
					<Footer
						address="30-36 O'Dea Avenue, Waterloo NSW 2017"
						logoLinkUrl=''
						openHours='Display Centre Open 7 Days, 10am to 4pm'
						extraText='Opening times TBA soon'
						socialLinks={{
							facebook : 'https://www.facebook.com/One-Space-Residences-and-Resorts-111218915019004',
							instagram: 'https://www.instagram.com/onespace_residences/',
							twitter  : 'https://www.tiktok.com/@onespace_residences',
							// youtube  : 'https://www.youtube.com/channel/UCFqtysbzDIz0AwXxk2zNWgg',
							// linkedin : 'https://www.linkedin.com/company/crown-international-holdings-group/',
							// wechat   : 'http://www.crowngroup.com.au/wechat/',
							// weibo    : 'http://www.weibo.com/crownpropertygroup',
						}}
						teams={[
							{
								name: 'Sydney Team',
								phone: '1800 931 680',
								detail: 'Mandarin, Cantonese, and Indonesian',
								email: 'sales@onespacegroup.com.au',
							},
							{
								name: 'Jakarta Team',
								phone: '+62 878 98888 098',
								detail: 'English and Indonesian',
								email: 'sales@onespacegroup.com.au',
							},
						]}
					/>
				)}
			</GlobalContextProvider>
		)}
	/>
)

Layout.propTypes = {
	children: PropTypes.node.isRequired,
}

export default Layout
